import { all, takeEvery, put, call, fork } from "redux-saga/effects";
import actions from "./actions";
import AxiosInterceptor from "../../Services/axiosIntercepter";
import { jwtDecode } from "jwt-decode";
import { encryptData, decryptData } from "../../redux/encryptiondecryption";
import { isEmpty } from "lodash";

// API call to refresh the access token
const refreshAccessToken = async (payload) => {
  const { url, body } = payload;
  const response = await AxiosInterceptor.post(url, body);
  return response;
};

// Decode access token to extract expiry time
const decodeAccessToken = (accessToken) => {
  try {
    const decoded = jwtDecode(accessToken);
    if (!decoded.exp) {
      throw new Error("The token does not have an 'exp' field.");
    }
    const expiryTimeInMs = decoded.exp * 1000;
    const expiryDate = new Date(expiryTimeInMs);
    return expiryDate.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      dateStyle: "medium",
      timeStyle: "medium",
    });
  } catch (error) {
    console.error("Failed to decode access token:", error);
    return null;
  }
};

const otpDetails = async (payload) => {
  const { url, body } = payload;
  const result = await AxiosInterceptor.post(url, body);
  return result;
};

export function* OTPSAGA() {
  yield takeEvery(actions.OTP_REQUEST, function* ({ payload }) {
    try {
      const res = yield call(otpDetails, payload);
      if (res.data.status_code === 1) {
        localStorage.setItem("loginType", res?.data?.login_type);
        const accessToken = res.data.access_token;
        const refreshToken = res.data.refresh_token;
        const accessTokenExpiry = decodeAccessToken(accessToken);

        // Encrypt and store the token data in localStorage
        const otpData = {
          accessToken,
          refreshToken,
          accessTokenExpiry,
          actionType: actions.OTP_SUCCESS,
        };
        encryptData(otpData); // Encrypt before storing

        // Handle donor data
        if (isEmpty(res?.data?.donor)) {
          localStorage.setItem("newStudent", true);
        } else {
          localStorage.setItem("donorId", res?.data?.donor?._id);
          sessionStorage.setItem("donorId", res?.data?.donor?._id);
          localStorage.setItem("email", res?.data?.donor?.email);
          localStorage.setItem("pannumber", res?.data?.donor?.pan_number);
          localStorage.setItem("name", res?.data?.donor?.name);
        }

        // Handle student data
        const studentArray = res?.data?.student || [];
        if (studentArray.length > 1) {
          // Extract only name and ID for multiple students
          const reducedStudents = studentArray.map(
            ({ name, student_id, _id }) => ({
              name,
              student_id,
              _id,
            })
          );
          localStorage.setItem("hasMultipleStudents", true);
          localStorage.setItem("students", JSON.stringify(reducedStudents)); // Store reduced array
          localStorage.setItem("newStudent", false); // Indicates a new student
        } else if (studentArray.length === 1) {
          localStorage.setItem("Student_Id", studentArray[0]._id); // Store Student_Id
          localStorage.setItem("hasMultipleStudents", false);
        } else {
          localStorage.setItem("hasMultipleStudents", false);
          localStorage.setItem("newStudent", true); // Indicates a new student
        }

        yield put({
          type: actions.OTP_SUCCESS,
          donorDetails: res.data.donor,
          successMessage: res.data.message,
          accessToken,
          refreshToken,
          accessTokenExpiry,
        });
      } else {
        yield put({
          type: actions.OTP_ERROR,
          errorMessage: res.data.message || "Please enter valid OTP",
        });
      }
    } catch (error) {
      yield put({
        type: actions.OTP_ERROR,
        errorMessage: "Please enter valid OTP.",
      });
    }
  });
}

export function* refreshTokenSaga() {
  yield takeEvery(actions.REFRESH_TOKEN_REQUEST, function* ({ payload }) {
    try {
      const response = yield call(refreshAccessToken, payload);
      if (response.data.status_code === 1) {
        const newAccessToken = response.data.access_token;
        const newRefreshToken = response.data.refresh_token;
        const newAccessTokenExpiry = decodeAccessToken(newAccessToken);

        // Encrypt and store the new token data in localStorage
        const otpData = {
          accessToken: newAccessToken,
          refreshToken: newRefreshToken,
          accessTokenExpiry: newAccessTokenExpiry,
          actionType: actions.REFRESH_TOKEN_SUCCESS,
        };
        encryptData(otpData); // Encrypt before storing

        yield put({
          type: actions.REFRESH_TOKEN_SUCCESS,
          accessToken: newAccessToken,
          refreshToken: newRefreshToken,
          accessTokenExpiry: newAccessTokenExpiry,
        });
      } else {
        yield put({
          type: actions.REFRESH_TOKEN_ERROR,
          errorMessage: "Failed to refresh token.",
        });
      }
    } catch (error) {
      yield put({
        type: actions.REFRESH_TOKEN_ERROR,
        errorMessage: "Failed to refresh token.",
      });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(OTPSAGA), fork(refreshTokenSaga)]);
}
